import { UrlConstants } from "../url.constants";
export class ApiModuleSettingConstants {
    static URL = UrlConstants.API_V2 + "ModuleSetting";
    static FUNCTION_GET_AFLA_PORTAL_SETTINGS = "GetAFLAPortalSettings";
}
